// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd73e075","453":"82664ad1","455":"0cfbb1b3","977":"d35f6e4e"}[chunkId] + ".chunk.js";
};